var map = {
	"./black_logo.png": 99,
	"./blank-bg.png": 100,
	"./gold-bg.jpg": 101,
	"./gold-laurus.png": 102,
	"./green-bg.jpg": 103,
	"./green-laurus.png": 104,
	"./white_logo.png": 105
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 227;


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/image_generator nonrecursive \.(png|jpe?g|svg)$
// module id = 227
// module chunks = 0 1